import React from "react";
import { primaryTextColor } from "../../utils/constants";

export default function IconMoreInfo({ color = primaryTextColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={21} height={21.004}>
      <path
        data-name="Vereinigungsmenge 15"
        d="M0 10.502a10.5 10.5 0 1 1 10.5 10.5A10.5 10.5 0 0 1 0 10.502Zm1.641 0A8.859 8.859 0 1 0 10.5 1.643a8.852 8.852 0 0 0-8.859 8.859Zm8.037 4.395V9.612a.822.822 0 0 1 1.643 0v5.285a.822.822 0 0 1-1.643 0Zm-.287-8.215A1.108 1.108 0 1 1 10.5 7.787a1.107 1.107 0 0 1-1.109-1.105Z"
        fill={color}
      />
    </svg>
  );
}
